import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAdmin } from "@/lib/admin-guard";

export const Route = createFileRoute("/admin_/contracts")({
  ssr: false,
  beforeLoad: requireAdmin,
  head: () => ({
    meta: [
      { title: "Contracts — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ContractsLayout,
});

function ContractsLayout() {
  return <Outlet />;
}
